import { CashBankSplitTransactionParams } from "../entities";
import { CashAndBankRepository } from "../repositories";

const toMinorUnits = (amount: number) => Math.round(amount * 100);

export class SplitCashBankTransactionUseCase {
  constructor(private repository: CashAndBankRepository) {}

  async execute(params: CashBankSplitTransactionParams): Promise<void> {
    if (!params.transactionId.trim()) {
      throw new Error("Transaction ID is required");
    }

    if (params.splits.length < 2) {
      throw new Error("At least two split rows are required");
    }

    params.splits.forEach((split, index) => {
      if (!split.description.trim()) {
        throw new Error(`Description is required for split row ${index + 1}`);
      }

      if (!Number.isFinite(split.amount) || split.amount <= 0) {
        throw new Error(`Amount must be greater than zero for split row ${index + 1}`);
      }
    });

    await this.repository.splitTransaction({
      transactionId: params.transactionId,
      splits: params.splits.map((split) => ({
        amount: toMinorUnits(split.amount) / 100,
        description: split.description.trim(),
      })),
    });
  }
}
